var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pageHeader'),_c('div',{staticClass:"iframeBox"},[_c('iframe',{ref:"iframe",attrs:{"allow":"fullscreen","id":"priceCounter_iframe","src":"https://www.e0123.cn/aivision/index.html"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }